import { RelationshipRecord, RelationshipType } from '../../components/Form/FamilyLaw/Relationship'
import { ProvisionalType } from '../../components/Form/FamilyLaw/Requests/Requests'
import { Acknowledgement } from '../../components/Form/FamilyLaw/Offspring/Dialog/OffspringDialog'
import { NaturalPersonMutationDto } from '../../components/Form/Party/NaturalPersonForm'
import { FileModuleDto } from './useFileModule'
import { ModuleType } from '../../context/GlobalContext'

export type FamilyLawModuleDto = FileModuleDto & {
    relationshipType: RelationshipType
    relationshipDate: string
    relationshipLocation?: string
    relationshipCountry?: string
    relationshipRecord: RelationshipRecord
    offspring: OffspringDto[]
    requests: RequestDto[]
}

export type OffspringDto = {
    child: Partial<NaturalPersonMutationDto>
    mainstay: string
    custody: string
    acknowledgement: string
}

export type RequestDto = {
    familyLawId: string
    type: string
    provisionalContent?: ProvisionalType[]
    meritContent?: string[]
    referenceDate?: string
    decreeDate?: string
    decreeRegisterDate?: string
}

export const baseFamilyLawValues: FamilyLawModuleDto = {
    offspring: [],
    relationshipCountry: '',
    relationshipDate: '',
    relationshipLocation: '',
    relationshipRecord: RelationshipRecord.CommonGoods,
    relationshipType: RelationshipType.Marriage,
    requests: [],
    type: ModuleType.FamilyLaw,
}

export function getDefaultOffspring(acknowledgement: Acknowledgement) {
    return {
        child: {
            name: {
                initials: '',
                first: '',
                given: '',
                insertion: '',
                last: '',
            },
            gender: undefined,
            identificationNumber: '',
            dateOfBirth: '',
        },
        mainstay: 'CLIENT',
        custody: 'JOINT',
        acknowledgement: acknowledgement,
    }
}

export function mapOffspring(offspring: OffspringDto) {
    return {
        child: {
            ...offspring.child,
            pivot: offspring.child.pivot ?? undefined,
        },
        mainstay: offspring.mainstay,
        custody: offspring.custody,
        acknowledgement: offspring.acknowledgement,
    }
}

export function getDefaultRequest(familyLawId: string): RequestDto {
    return {
        familyLawId: familyLawId,
        referenceDate: '',
        type: undefined,
        provisionalContent: [],
        meritContent: [],
    }
}

export function mapFamilyLawDto(values: FamilyLawModuleDto): FamilyLawModuleDto {
    return {
        ...values,
        offspring: values.offspring.map(mapOffspring),
    }
}
